// panning variables
export const panSpeed = 90
export const panBoundary = 20
export const direction = { left: 'LEFT', right: 'RIGHT', up: 'UP', down: 'DOWN' }
export const MAX_IMG_UPLOAD = 10
